module.exports = __webpack_public_path__ + "media/images/ioscor_google-b5da882dde34e7f24c60f782d7d8b2d3.png";